import { get, post, put, del } from './requests'

const resourcePath = 'contacts'

export function listContacts () {
  return get(resourcePath)
}

export function searchContacts (filters) {
  return get(resourcePath, filters)
}

export function showContact (id) {
  return get(`${resourcePath}/${id}`)
}

export function createContact (data) {
  return post(`${resourcePath}`, { contact: data })
}

export function updateContact (contact) {
  return put(`${resourcePath}/${contact.id}`, { contact })
}

export function deleteContact (id) {
  return del(`${resourcePath}/${id}`)
}

export function archiveContacts (ids, page = 1) {
  return post(`${resourcePath}/archive`, { contact_ids: [ids], page })
}

export function applyContactLabels (id, labelIds) {
  return post(`${resourcePath}/${id}/apply_labels`, { labelIds })
}

export function existsContact (email, name) {
  return get(`${resourcePath}/exists`, { email, name })
}

export function createExistingContact (email, name) {
  return post(`${resourcePath}/existing`, { contact: { email, name } })
}
